import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import KitchenModal from "../kitchenList/KitchenModal";
import Paginations from "../../../components/paginaton/Paginations";

const KitchenArchiveOrders = () => {
  const { branchId } = useParams();
  const [collapsed, setCollapsed] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    cashDeskId: 0,
    saleUnitId: 0,
    categoryId: 0,
    orderType: 0,
    posDeviceId: 0,
    size: 50,
    part: 1,
    invoiceNumber: "",
    orderNumber: 0,
    merchantName: "",
    merchantPhone: "",
    merchantCode: "",
    paymentType: 0,
    orderStatus: 0,
    startDate: "",
    endDate: "",
    total: 0,
    parts: 0,
  });
  const [loading, setLoading] = useState(true);
  const [orderTypes, setOrderTypes] = useState([]);
  const [units, setUnits] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [show, setShow] = useState(null);

  const handleClose = () => setShow(null);
  const handleShow = (id) => {
    setShow(id);
  };

  const getGridData = async () => {
    const kitchenOrdersResp = await apiMethod.getKitchenArchive(
      branchId,
      filterModel.saleUnitId,
      filterModel.orderNumber,
      filterModel.cashDeskId,
      filterModel.posDeviceId,
      filterModel.invoiceNumber,
      filterModel.merchantName,
      filterModel.merchantPhone,
      filterModel.merchantCode,
      filterModel.orderType,
      filterModel.paymentType,
      filterModel.orderStatus,
      filterModel.startDate,
      filterModel.endDate,
      filterModel.part,
      filterModel.size
    );

    if (methods.showApiErrors(kitchenOrdersResp)) {
      setGridData(kitchenOrdersResp.data);
      filterModel.total = kitchenOrdersResp.total;
      filterModel.parts = methods.calcPageParts(
        kitchenOrdersResp.total,
        filterModel.size
      );
      setFilterModel({ ...filterModel });
      setGridData(kitchenOrdersResp.data);
    }
  };

  const getBaseInfo = async () => {
    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);

    const resp2 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp2)) setUnits(resp2.data);
  };

  // const cancelOrder = async (invoiceId) => {
  //   setLoading(true);
  //   var resp = await apiMethod.kitchenCancelOrder(invoiceId);
  //   if (!methods.showApiErrors(resp)) {
  //     setLoading(false);
  //     return false;
  //   }

  //   await getGridData();
  //   setLoading(false);
  // };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      createConnection();
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };

    bindData();
  }, [branchId]);

  // const movePagerPart = (isForward) => {
  //   if (isForward) {
  //     if (filterModel.parts < filterModel.part + 1) {
  //       return false;
  //     }
  //     callPager(filterModel.part + 1);
  //   } else {
  //     if (filterModel.part === 1) {
  //       return false;
  //     }
  //     callPager(filterModel.part - 1);
  //   }
  // };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  // const makePagerItems = () => {
  //   let pages = [];
  //   for (let i = 1; i <= filterModel.parts; i++) {
  //     pages.push(
  //       <li
  //         key={i}
  //         className={
  //           filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
  //         }
  //       >
  //         <a
  //           className="page-link circular-pagination"
  //           onClick={() => {
  //             callPager(i);
  //           }}
  //         >
  //           {i}
  //         </a>
  //       </li>
  //     );
  //   }
  //   return pages;
  // };

  // const changeToCooked = async (id) => {
  //   try {
  //     setLoading(true);
  //     const resp = await apiMethod.changeToCookedOrder(id);

  //     if (!methods.showApiErrors(resp)) return false;

  //     await getGridData();
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const backtoCurrentOrder = async (id) => {
  //   try {
  //     setLoading(true);
  //     const resp = await apiMethod.backToCurrentOrder(id);

  //     if (!methods.showApiErrors(resp)) return false;

  //     await getGridData();
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.cashDeskId = 0;
    filterModel.saleUnitId = 0;
    filterModel.categoryId = 0;
    filterModel.orderType = 0;
    filterModel.posDeviceId = 0;
    filterModel.size = 50;
    filterModel.part = 1;
    filterModel.invoiceNumber = "";
    filterModel.orderNumber = 0;
    filterModel.merchantName = "";
    filterModel.merchantPhone = "";
    filterModel.merchantCode = "";
    filterModel.paymentType = 0;
    filterModel.orderStatus = 0;
    filterModel.startDate = "";
    filterModel.endDate = "";
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const selectedItem = gridData.find((item) => item.id === show);

  const URL =
    process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(URL)
      .withAutomaticReconnect()
      .build();
    await conn
      .start()
      .catch((err) => console.log(err))
      .then(() => {
        conn.invoke("GetConnectionId").then(function (connectionId) {
          console.log("connectionId: " + connectionId);
        });
      });
    conn.on("ReceiveNewOrderPanel", (bid, orderId, status) => {
      if (status === 1) getGridData();
    });
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const renderLists = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <div className="row bg-light">
            <div
              className={`col-12 ${
                collapsed ? "col-lg-1" : "col-lg-2"
              } border-end border-secondary-subtle p-0 bg-white`}
            >
              <div className="d-flex justify-content-end pt-4">
                <span className="toggleImg" onClick={toggleSidebar}>
                  {collapsed ? (
                    <i className="bi bi-arrow-left-circle fs-5"></i>
                  ) : (
                    <i className="bi bi-arrow-right-circle fs-5"></i>
                  )}
                </span>
              </div>
              <div className="d-flex flex-column gap-3 px-4 mt-5">
                <button className="btn btn-purple">آرشیو لیست آشپزخانه</button>
                <Link to={`/kitchen/${branchId}/orders`} className="w-100">
                  <button className="btn btn-outline-purple w-100">
                    لیست آشپزخانه
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-12 col-lg-10">
              <div className="d-none d-lg-block text-start mb-3">
                <Link to={`/kitchen`} className="link back-link">
                  <span>
                    <img src={back} alt="return" />
                  </span>
                  بازگشت
                </Link>
              </div>
              <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
                <div>
                  <Link to={`/sale/${branchId}/#1`} className="link back-link">
                    <span>
                      <img src={back} className="" alt="return" />
                    </span>
                  </Link>
                  داشبورد
                </div>
                <p className="date">{methods.currentDate()}</p>
              </div>
              <div className="saleheader d-none d-lg-block">
                <p>
                  لیست آشپزخانه
                  <a
                    href={`/sale/${branchId}/softwareGuide/#section13`}
                    className="link rtlicon me-1"
                    title="برای اطلاعات بیشتر کلیک کنید"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-question-circle"></i>
                  </a>
                </p>
              </div>
              <div className="salemain">
                <div className="salesearchsection py-4">
                  <div className="row gap-4 gap-lg-0">
                    <div className="col-12">
                      <div className="row gap-y-3" style={{ rowGap: "12px" }}>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="searchInput" className="form-label">
                            نام
                          </label>
                          <div className="hstack">
                            <input
                              id="searchInput"
                              className="form-control"
                              type="text"
                              style={{ direction: "rtl", textAlign: "right" }}
                              value={filterModel.merchantName}
                              onChange={(e) => {
                                filterModel.merchantName = e.target.value;
                                setFilterModel({ ...filterModel, part: 1 });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="searchInput" className="form-label">
                            شماره سفارش
                          </label>
                          <div className="hstack">
                            <input
                              id="searchInput"
                              className="form-control"
                              type="text"
                              style={{ direction: "rtl", textAlign: "right" }}
                              value={filterModel.orderNumber}
                              onChange={(e) => {
                                filterModel.orderNumber = e.target.value;
                                setFilterModel({ ...filterModel, part: 1 });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="searchInput" className="form-label">
                            شماره فاکتور
                          </label>
                          <div className="hstack">
                            <input
                              id="searchInput"
                              className="form-control"
                              type="text"
                              style={{ direction: "rtl", textAlign: "right" }}
                              value={filterModel.invoiceNumber}
                              onChange={(e) => {
                                filterModel.invoiceNumber = e.target.value;
                                setFilterModel({ ...filterModel, part: 1 });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="searchInput" className="form-label">
                            شماره اشتراک
                          </label>
                          <div className="hstack">
                            <input
                              id="searchInput"
                              className="form-control"
                              type="text"
                              style={{ direction: "rtl", textAlign: "right" }}
                              value={filterModel.merchantCode}
                              onChange={(e) => {
                                filterModel.merchantCode = e.target.value;
                                setFilterModel({ ...filterModel, part: 1 });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="ddlStatuses" className="form-label">
                            بخش های فروش
                          </label>
                          <select
                            id="ddlStatuses"
                            className="form-select"
                            aria-label="menu"
                            value={filterModel.saleUnitId}
                            onChange={(e) => {
                              filterModel.saleUnitId = e.target.value;
                              setFilterModel({ ...filterModel });
                            }}
                          >
                            <option value={0}>همه بخش ها</option>
                            {units.map((item, index) => (
                              <option value={item.id} key={index}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="filters" className="form-label">
                            نوع سفارش
                          </label>
                          <select
                            id="filters"
                            className="form-select"
                            aria-label="menu"
                            value={filterModel.orderType}
                            onChange={(e) => {
                              filterModel.orderType = e.target.value;
                              setFilterModel({ ...filterModel });
                            }}
                          >
                            <option value={0}>همه</option>
                            {orderTypes.map((item, index) => (
                              <option value={item.id} key={index}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="enddate" className="form-label">
                            از تاریخ
                          </label>
                          <DatePicker
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition="bottom-center"
                            format="YYYY/MM/DD"
                            value={filterModel.startDate}
                            onChange={(value) => {
                              if (value)
                                filterModel.startDate =
                                  value.format("YYYY/MM/DD");
                              else filterModel.startDate = "";
                              setFilterModel({ ...filterModel });
                            }}
                            inputClass="form-control"
                            containerStyle={{
                              width: "100%",
                            }}
                          />
                        </div>
                        <div className="col-12 col-lg-2 col-md-4 col-sm-6">
                          <label htmlFor="enddate" className="form-label">
                            تا تاریخ
                          </label>
                          <DatePicker
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition="bottom-center"
                            format="YYYY/MM/DD"
                            value={filterModel.endDate}
                            onChange={(value) => {
                              if (value)
                                filterModel.endDate =
                                  value.format("YYYY/MM/DD");
                              else filterModel.endDate = "";
                              setFilterModel({ ...filterModel });
                            }}
                            inputClass="form-control"
                            containerStyle={{
                              width: "100%",
                            }}
                          />
                        </div>
                        <div className="col-12 col-lg-2 col-md-3 col-sm-4">
                          <div className="pt-4 mt-2">
                            <button
                              type="button"
                              className="btn btn-purple me-1"
                              onClick={searchItem}
                            >
                              <i className="bi bi-search"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-info"
                              onClick={clearSearch}
                            >
                              <i className="bi bi-arrow-clockwise"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive text-center">
                  <table className="table table-bordered">
                    <thead className="align-middle">
                      <tr>
                        <th>ردیف</th>
                        <th>نام و نام خانوادگی</th>
                        <th>شماره موبایل</th>
                        <th>شماره فاکتور</th>
                        <th>شماره سفارش</th>
                        <th>شماره اشتراک</th>
                        <th>وضعیت</th>
                        <th>تاریخ و ساعت</th>
                        <th>نوع سفارش</th>
                        <th>آدرس</th>
                        <th>عملیات</th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {gridData.map((item, index) => (
                        <tr key={item.id}>
                          <td>
                            {(filterModel.part - 1) * filterModel.size +
                              index +
                              1}
                          </td>
                          <td>{item.merchantName}</td>
                          <td>{item.merchantPhone}</td>
                          <td>{item.invoiceNumber}</td>
                          <td>{item.orderNumber}</td>
                          <td>{item.merchantCode}</td>
                          <td>{item.orderStatusName}</td>
                          <td>
                            {methods.toPersianDate(
                              item.createDate,
                              "jYYYY/jMM/jDD"
                            )}{" "}
                            - {methods.toPersianDate(item.createDate, "HH:MM")}
                          </td>
                          <td>
                            {
                              orderTypes.find(
                                (orderType) => orderType.id === item.orderType
                              )?.title
                            }
                          </td>
                          <td width={"35%"} className="break-text">{item.destination}</td>
                          <td>
                            <button
                            onClick={() => handleShow(item.id)}
                              className="btn btn-sm btn-outline-purple"
                              type="button"
                            >
                              <i className="bi bi-file-text"></i>
                            </button>
                            <KitchenModal
                              id={item.id}
                              show={show === item.id}
                              onHide={handleClose}
                              selectedItem={selectedItem}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="d-flex align-items-center justify-content-center">
                    {filterModel.parts > 1 && (
                      <Paginations
                        total={filterModel.total}
                        size={filterModel.size}
                        onPageChange={callPager}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </>
    );
  };

  return <>{renderLists()}</>;
};

export default KitchenArchiveOrders;
